import React from 'react';
//verificacion
interface WorldIconProps {
  width?: number;
  height?: number;
  color?: string;
  style?: React.CSSProperties;
  className?: string;
}

const WorldIcon: React.FC<WorldIconProps> = ({
  width = 16,
  height = 16,
  color = "#C10D28",
  style,
  className,
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={style}
    className={className}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.864 1.938A6.17 6.17 0 001.853 7.5h3.002a10.7 10.7 0 012.009-5.562zm2.272 0A10.7 10.7 0 0111.145 7.5h3.001a6.17 6.17 0 00-5.01-5.562zM10.142 7.5A9.7 9.7 0 008 2.1a9.7 9.7 0 00-2.143 5.4h4.285zm-4.285 1h4.285A9.7 9.7 0 018 13.9a9.7 9.7 0 01-2.143-5.4zm-1.002 0H1.853a6.17 6.17 0 005.01 5.562A10.7 10.7 0 014.856 8.5zm4.28 5.562a10.7 10.7 0 002.01-5.562h3.001a6.17 6.17 0 01-5.01 5.562zM.833 8v-.002a7.167 7.167 0 1114.333 0A7.167 7.167 0 01.833 8z"
      fill={color}
    />
  </svg>
);

export default WorldIcon;
